module.exports = __webpack_public_path__ + "static/media/main-small-section-left-2.abad4589.png";